import { TransactionQueryKeys } from '../../../keys'
import bankTransactionService from '../../services'
import type {
	GetTransactionStatisticsParams,
	TransactionStatisticsResponse,
} from '../../../types'
import { UnusedSkipTokenOptions } from '@tanstack/react-query'

export const transactionStatisticsQueryOptions = (
	params?: GetTransactionStatisticsParams,
	options?: UnusedSkipTokenOptions<TransactionStatisticsResponse>,
) => ({
	queryKey: [TransactionQueryKeys.TRANSACTION_STATISTICS, params],
	queryFn: () => bankTransactionService.getTransactionStatistics(params),
	staleTime: 5 * 60 * 1000, // 5 minutes
	gcTime: 10 * 60 * 1000, // 10 minutes
	...options,
})
